import { useState, useEffect, useCallback } from 'react';
import { ApiEndpoints } from 'services/endpoints';
import { apiService } from 'services/service';

export function useCheckout({ enabled = false } = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCheckout = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiService.post({
                url: ApiEndpoints.CHECKOUT_CART,
            });
            setData(response.data || response);
        } catch (err) {
            const errorData = err || {};
            setData(errorData);
            setError(errorData.message || 'Failed to load checkout information');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (enabled) {
            fetchCheckout();
        }
    }, [enabled, fetchCheckout]);

    return { data, loading, error, refetch: fetchCheckout };
}
